@if (layoutMode() === 'blank') {
  <router-outlet />
} @else if (layoutMode() === 'patient') {
  <div class="patient-shell">
    <router-outlet />
  </div>
} @else {
  <nz-layout class="app-shell">
    <nz-header class="brand-bar">
      <div class="brand-bar__left">
        <button
          nz-button
          nzType="text"
          class="sider-toggle"
          (click)="toggleSider()"
          [nz-tooltip]="siderCollapsed() ? ('nav.expandMenu' | translate) : ('nav.collapseMenu' | translate)"
          nzTooltipPlacement="bottom"
          aria-label="Toggle menu"
        >
          <svg
            lucideMenu
            class="topbar-icon topbar-icon--toggle topbar-icon--hamburger"
            size="32"
            strokeWidth="3.2"
          ></svg>
        </button>

        <a [routerLink]="homeLink()" class="app-brand">
          <img src="logo.png" alt="" class="brand-icon" />
          <span class="brand-name">{{ appName() }}</span>
        </a>
      </div>

      <div class="brand-bar__center">
        <span class="page-title">{{ pageTitle() }}</span>
      </div>

      <div class="brand-bar__right">
        @if (!isOnline()) {
          <div
            class="sync-toolbar"
            role="status"
            [attr.aria-label]="connectivityLabel()"
          >
            <span
              class="sync-toolbar__status"
              [ngClass]="connectivityChipClass()"
              [nz-tooltip]="connectivityHint()"
              nzTooltipPlacement="bottom"
            >
              <span class="sync-toolbar__dot" aria-hidden="true"></span>
              <span class="sync-toolbar__label">{{ connectivityLabel() }}</span>
            </span>
          </div>
        }

        <a
          nz-dropdown
          [nzDropdownMenu]="userMenu"
          nzTrigger="click"
          class="user-trigger"
        >
          <nz-avatar
            [nzSrc]="userAvatarUrl() ?? undefined"
            nzIcon="user"
            nzSize="small"
          ></nz-avatar>
          <span class="user-name">{{ userName() }}</span>
          <svg lucideChevronDown class="topbar-icon topbar-icon--small"></svg>
        </a>

        <nz-dropdown-menu #userMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="navigateFromUserMenu('/profile')">
              <svg lucideUser class="menu-inline-icon"></svg>
              {{ 'nav.profile' | translate }}
            </li>
            <li nz-menu-item (click)="navigateFromUserMenu('/settings')">
              <svg lucideSettings class="menu-inline-icon"></svg>
              {{ 'nav.settings' | translate }}
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="logout()">
              <svg lucideLogOut class="menu-inline-icon"></svg>
              {{ 'nav.logout' | translate }}
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>

    <nz-layout class="app-body">
      <nz-sider
        class="app-sider"
        nzTheme="light"
        [nzCollapsed]="siderCollapsed()"
        [nzCollapsible]="true"
        [nzTrigger]="null"
        [nzWidth]="240"
        [nzCollapsedWidth]="64"
      >
        <app-side-menu [collapsed]="siderCollapsed()" [isAdmin]="isAdmin()" />
      </nz-sider>

      <nz-layout class="app-main">
        <nz-content class="app-content">
          <div class="content-inner">
            <div class="page-bar">
              <nz-breadcrumb>
                @for (item of breadcrumbItems(); track item.url) {
                  <nz-breadcrumb-item>
                    <a [routerLink]="item.url">{{ item.label }}</a>
                  </nz-breadcrumb-item>
                }
              </nz-breadcrumb>

              @let actionsTpl = pageActions.template();
              @if (actionsTpl) {
                <div class="page-bar__actions">
                  <ng-container [ngTemplateOutlet]="actionsTpl" />
                </div>
              }
            </div>

            <router-outlet />
          </div>
        </nz-content>
      </nz-layout>
    </nz-layout>
  </nz-layout>

  <nz-modal
    [nzVisible]="!!gate.blocked()"
    [nzClosable]="false"
    [nzMaskClosable]="false"
    [nzTitle]="'sync.subscriptionRequired' | translate"
    (nzOnCancel)="dismissGate()"
  >
    <ng-container *nzModalContent>
      @if (gate.blocked(); as info) {
        <p>{{ info.message }}</p>
        @if (info.reason === 'trial_expired') {
          <p>{{ 'sync.trialExpired' | translate }}</p>
        } @else {
          <p>{{ 'sync.subscriptionInactive' | translate }}</p>
        }
      }
    </ng-container>
    <div *nzModalFooter>
      <button nz-button (click)="dismissGate()">{{ 'common.close' | translate }}</button>
      <button nz-button nzType="primary" (click)="openBillingPortal()">
        {{ 'sync.openBillingPortal' | translate }}
      </button>
    </div>
  </nz-modal>
}

<app-export-progress-overlay />
